/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CheckoutSessionResponse interface.
 */
export function instanceOfCheckoutSessionResponse(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
export function CheckoutSessionResponseFromJSON(json) {
    return CheckoutSessionResponseFromJSONTyped(json, false);
}
export function CheckoutSessionResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
    };
}
export function CheckoutSessionResponseToJSON(json) {
    return CheckoutSessionResponseToJSONTyped(json, false);
}
export function CheckoutSessionResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
    };
}
